import { Input } from './input';

/**
 * Handler for single value input fields (text inputs, textareas, select, radio inputs, etc.)
 */

export class SingleValueInput extends Input {

	/**
	 * @param {HTMLElement} elem - the input type text field
	 * @param {FormHandler} form - the form, the current element belongs to
	 * @constructor
	 */
	constructor(elem, form) {
		super(elem, form);
		this.addEventHandlers();
		this.init();
	}

	static getSelector() {
		return 'input[type="text"]:not([name="somePrefix_nickname"]),' +
			'input[type="password"],' +
			'input[type="email"],' +
			'input[type="date"],' +
			'textarea,' +
			'select'
	}

	init() {
		this.checkElemValue();
		this.checkDisabled();
	}

	onBlurElem() {
		super.onBlurElem();
		this.checkElemValue();
	}

	checkElemValue() {
		this.hasContent = this.elem.value || this.elem.placeholder;
		this.setContentClass();
	}

	checkDisabled() {
		if(this.elem.hasAttribute('disabled')) {
			this.holder.classList.add(Input.STATES.DISABLED);
		}
	}

	setContentClass() {
		this.hasContent || this.isSelect ? this.holder.classList.remove(Input.STATES.NO_CONTENT) : this.holder.classList.add(Input.STATES.NO_CONTENT);
	}

	get isSelect() {
		return this.elem.tagName === 'SELECT';
	}
}

